
<div class="flexColumn category-filter">
  <div class="filter-box mb11 flexRowS">
    <span class="label-name mr35" style="margin-top: -1px">
      <template v-if="$attrs.title.length == 2">
        {{ $attrs.title[0] }}
        &nbsp;&nbsp;&nbsp;
        {{ $attrs.title[1] }}
      </template>
      <template v-else>
        {{ $attrs.title }}
      </template>
    </span>
    <div class="filter-box-content">
      <div class="filter-left flexRowS">
        <div class="filter-item" :class="{ checked: isAllSelected }" @click="selectAll">全部</div>
        <div
          class="filter-item"
          v-for="item in level1Data"
          :key="item.value"
          :class="{ checked: selectedValues.includes(item.value) }"
          @click="changeFilter(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="filter-box-right" v-if="isLevel1More" @click="level1More = !level1More">
        更多
        <van-icon class="icon" :class="{ up: !level1More }" name="arrow-down" />
      </div>
    </div>
  </div>
  <div
    class="level2-box flexRowSB"
    v-if="$attrs.category2List && $attrs.category2List.length > 0"
  >
    <div class="level2-box-left flexRowS" :class="{ openDiv: !level2More, closeDiv: level2More }" ref="level2Box">
      <div class="filter-item" :class="{ checked: isAllSelected2 }" @click="select2All">全部</div>
      <div
        class="filter-item"
        v-for="item in level2List"
        :key="item.value"
        :class="{ checked: selectedLevel2Values.includes(item.value) }"
        @click="change2Filter(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <div
      class="filter-box-right"
      @click="level2More = !level2More"
      v-if="isShowMore"
    >
      <van-icon class="icon" :class="{ up: !level2More }" name="arrow-down" />
    </div>
  </div>
</div>
